import { makeStyles } from '@material-ui/styles';
import { alpha } from '@material-ui/core/styles/colorManipulator';

export default makeStyles((theme) => ({
  addButton: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.background.light,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    }
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0),
    height: 1,
    backgroundColor: '#D8D8D880',
  },
  botaoDireta: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  centraliza: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    marginTop: theme.spacing(5)
  },
  box: {
    width: '200px',
    height: '200px',
    backgroundColor: theme.palette.text.hint,
    borderRadius: 20,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.warning.light,
    }
  },
  boxSelected: {
    backgroundColor: theme.palette.warning.main
  },
  item2: {
    order: 3,
    [theme.breakpoints.up('sm')]: {
      order: 2,
    },
  },
  item3: {
    order: 2,
    [theme.breakpoints.up('sm')]: {
      order: 3,
    },
  },
  customBoxBg: {
    backgroundColor: theme.palette.primary.extralight,
    fontSize: 16
  },
  font16: {
    fontSize: 16
  },
  loading: {
    height: 600,
    marginTop: -120
  },
  backdrop: {
    backgroundColor: alpha(theme.palette.primary.main, 0.5),
  },
  flatTable: {
    '& > .MuiPaper-root': {
      boxShadow: 'none',
    },
  },
}));
